export const dataHooks = {
  face: 'face',
};

export const facesData = {
  1: { name: 'disapointed', tooltipDataHook: 'disapointedTooltip' },
  2: { name: 'frowning', tooltipDataHook: 'frowningTooltip' },
  3: { name: 'neutral', tooltipDataHook: 'neutralTooltip' },
  4: { name: 'smiling', tooltipDataHook: 'smilingTooltip' },
  5: { name: 'grining', tooltipDataHook: 'griningTooltip' },
};
